import React, { useEffect, useRef, useState } from 'react'
import './element-data-view.styles.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { ModalAlert } from '@/components/modal/modal.component';
import { getPlayerDataFromDb } from '@/utils/getDataFromDb';
import SingleRowData from './single-row-data.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { properCase } from '@/utils/properCase';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';

const ElementDataView = ({
  gameElements,
  gamePlayers
}) => {

  const { elementId } = useParams();
  const [elementData, setElementData] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);
  const approveRef = useRef();
  const navigate = useNavigate();
  let playerListener;

  useEffect(() => {

    return () => {
      if (playerListener) playerListener();
    }
  }, [])

  useEffect(() => {
    console.log('ElementDataView', gameElements, gamePlayers, elementId);
    if (!gameElements || !gamePlayers || !elementId) return;
    let type = 'element';
    let element = gameElements[elementId];
    if (!element) {
      type = 'player';
      element = gamePlayers[elementId];
    };
    if (!element) {
      setAlertMessage('Element not found');
      approveRef.current = () => {
        navigate(-1)
      }
      return;
    }
    if (type === 'player') {
      getPlayerDataFromDb({
        'playerId': elementId,
        'callback': callback,
        'handleListener': handleListener
      })
      function callback(data) {
        console.log('Player data', data);
        setElementData(data);
      }
      function handleListener(unsub) {
        playerListener = unsub;
      }
    } else {
      setElementData(element);
    }
    console.log(element);
  }, [gameElements, gamePlayers, elementId])

  return (
    <div className='element-data-view'>
      {
        (elementData && !elementData.playerId) &&
        <div className='element-data-header'>
          <div className='element-icon'>
            <ImageContainer
              src={elementData.icon} />
          </div>
          <div>
            <h2>{elementData.name}</h2>
            {elementData.type && properCase(elementData.type)}
            {elementData.type === 'item' && <span> - {properCase(elementData.opt_itemType)}</span>}
          </div>
        </div>
      }
      {
        (elementData && elementData.playerId) &&
        <div className='element-data-header'>
          <div className='element-icon'>
            <UserIcon profile={elementData} noHover={true} />
          </div>
          <div className='name'>
            <h2>{elementData.fName} {elementData.lName ?? ''}</h2>
            <div>{elementData.team ? 'Team' : 'Player'}</div>
          </div>
        </div>
      }
      <div className='g-space-1'></div>
      {
        (elementData) &&
        Object.keys(elementData)
          .sort()
          .map(key => {
            let data = elementData[key];
            if (
              data && typeof data === 'object'
            ) {
              console.log('object data', key, data);
              return (
                <div key={key} className='info-div'>
                  <div className='info-div-single'>
                    <b>{key}</b>
                  </div>
                  <div className='object-key'>
                    {
                      Object.keys(data)
                        .map((k, i) => {
                          let objData = data[k]
                          // console.log(k);
                          // console.log(objData);
                          if (typeof objData === 'object') {
                            return (
                              <div key={k} className='object-key'>
                                <div className='info-div-single'>
                                  <b>{k}</b>
                                </div>
                                {
                                  Object.keys(objData)
                                    .sort()
                                    .map((newKey, j) => {
                                      let newData = objData[newKey];
                                      // console.log(newKey);
                                      if (typeof newData === 'object') {
                                        return (
                                          <div className='object-key'>
                                            {typeof newData}
                                            <div className='info-div-single'>
                                              <b>{newKey}</b>
                                            </div>
                                            {
                                              Object.keys(newData)
                                                .sort()
                                                .map((newestKey, k) => {
                                                  let newestData = newData[newestKey];
                                                  <SingleRowData
                                                    dataKey={newestKey}
                                                    data={newestData} />
                                                })
                                            }
                                          </div>
                                        )
                                      } else {
                                        return (
                                          <div key={j} className='object-key'>
                                            <SingleRowData
                                              dataKey={newKey}
                                              data={objData[newKey]} />
                                          </div>
                                        )
                                      }
                                    })
                                }
                              </div>
                            )
                          }
                          return (
                            <div key={i} className='object-key-div'>
                              <SingleRowData
                                dataKey={k}
                                data={objData} />
                            </div>
                          )
                        })
                    }
                  </div>
                </div>
              )
            } else {
              return (
                <div key={key} className='info-div-single'>
                  <SingleRowData
                    dataKey={key}
                    data={data} />
                </div>
              )
            }
          })
      }
      <ModalAlert
        show={alertMessage}
        message={alertMessage}
        cancel={() => setAlertMessage(null)}
        onApprove={approveRef.current} />
    </div>
  )
}

export default ElementDataView;

;